import {HttpInterceptor} from '@angular/common/http'
import {InjectionToken} from '@angular/core'

/**
 * Allows to override default dynamic interceptors that can be disabled with the HttpService extension.
 * Except for very specific needs, you should better configure these interceptors directly in the constructor below
 * for better readability.
 *
 * For static interceptors that should always be enabled (like ApiPrefixInterceptor), use the standard
 * HTTP_INTERCEPTORS token.
 */
export const HTTP_DYNAMIC_INTERCEPTORS = new InjectionToken<HttpInterceptor>('HTTP_DYNAMIC_INTERCEPTORS')
export const API_END_POINT_INTERCEPTOR = 'ApiEndPointInterceptor'
export const ERROR_HANDLER_INTERCEPTOR = 'ErrorHandlerInterceptor'
export const AUTH_TOKEN_INTERCEPTOR = 'AuthTokenInterceptor'
